require('gsap');
require('../vendor/gsap/plugins/MorphSVGPlugin');

var ScrollMagic = require('ScrollMagic');
require('animation.gsap');
require('debug.addIndicators');


let introBGSVGs = null;
const sectionsScenes = [];
const controller = new ScrollMagic.Controller();

const _updateIntroBGSVGs = (viewportWidth, viewportHeight) => {
  "use strict";

  let viewBox = `0 0 ${viewportWidth} ${viewportHeight}`;
  let cD = Math.round(viewportHeight * 0.00);
  let d = `M0,0h${viewportWidth}v${viewportHeight - cD}c0,0-${Math.round(viewportWidth / 2 * 0.75)},${cD}-${Math.round(viewportWidth / 2)},${cD}S0,${viewportHeight - cD},0,${viewportHeight - cD}V0z`;
  let cDAnimated = Math.round(viewportHeight * 0.08);
  let section1AnimationD = `M0,0h${viewportWidth}v${viewportHeight - cDAnimated}c0,0-${Math.round(viewportWidth / 2 * 0.75)},${cDAnimated}-${Math.round(viewportWidth / 2)},${cDAnimated}S0,${viewportHeight - cDAnimated},0,${viewportHeight - cDAnimated}V0z`;

  for (let i = 0; i < introBGSVGs.length; i++) {
    introBGSVGs[i].getElementById('betweenSectionStart_1_').setAttribute('cx', viewportWidth / 2);
    introBGSVGs[i].getElementById('betweenSectionStart_1_').setAttribute('cy', viewportHeight / 2);
    introBGSVGs[i].getElementById('betweenSectionStart_1_').setAttribute('r', viewportWidth / 2);
    introBGSVGs[i].setAttribute('viewBox', viewBox);
    introBGSVGs[i].getElementsByTagName('path')[0].setAttribute('d', d);

    if (!sectionsScenes[i]) {
      sectionsScenes.push(
        new ScrollMagic.Scene({
          triggerElement: '.trigger-section_bg',
          offset: 100,
          triggerHook: 'onLeave'
        }).addTo(controller)
          .setTween(TweenMax.to(introBGSVGs[i].getElementsByTagName('path')[0], 1, {morphSVG: section1AnimationD, ease:  Elastic.easeOut.config(2.5, 0.5)}))
      )
    }

  }
};


const initBGSections = (BGClass) => {
  "use strict";

  introBGSVGs = document.getElementsByClassName(BGClass);

  //reponsive utilites
  const resizeWindow = () => {
    const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    const fullHeightSections = document.getElementsByClassName('section--fullheight');

    for (let i = 0; i < fullHeightSections.length; i++) {
      fullHeightSections[i].style.minHeight = height + 'px';
    }

    _updateIntroBGSVGs(width, height);
  };

  window.onresize = resizeWindow;


  resizeWindow();

  //resize if DOMContentLoaded
  document.addEventListener("DOMContentLoaded", () => resizeWindow);
};





export default initBGSections;







/** WEBPACK FOOTER **
 ** ./src/script/sections.js
 **/